import { BASE_CDN_URL } from './constants';

//returns coupon code
export const getFreeCoupon = (company, optionalCoupon) => {
  company = company.toLowerCase();
  switch (company) {
    default:
      return company;
  }
};

// returns if a company is elgible for free coupon
export const isFreeCoupon = (company) => {
  company = company.toLowerCase();
  switch (company) {
    default:
      return false;
  }
};

// returns if a company is elgible for claim coupon
export const isClaimCoupon = (company) => {
  company = company.toLowerCase();
  switch (company) {
    default:
      return false;
  }
};

// returns company theme
export const getCompanyTheme = (company) => {
  return '#F9B257';
};

export const getCompanySloganTheme = (company) => {
  return null;
};

// returns company name
export const getCompanyName = (company) => {
  return 'Dawn DTx';
};

// returns company logo
export const getLogo = (company) => {
  return BASE_CDN_URL + '/dawn-icon.png';
};

// returns company background image (right container)
export const getBackgroundImg = (company) => {
  return BASE_CDN_URL + '/fish-bg.jpg';
};

export const returnErrorMessage = (serverMessage) => {
  switch (serverMessage) {
    case 'ServerAccountAlreadyRegistered':
      return 'ServerAccountAlreadyRegistered';
    case 'ServerInvalidPassword':
      return 'ServerInvalidPassword';
    case 'ServerInvalidEmail':
      return 'ServerInvalidEmail';
    case 'ServerNoMatchingAccount':
      return 'ServerNoMatchingAccount';
    case 'ServerPasswordIncorrect':
      return 'ServerPasswordIncorrect';
    case 'GSCNotVerified':
      return 'GSCNotVerified';
    case 'DependentInvalid':
      return 'DependentInvalid';
    default:
      return serverMessage;
  }
};

export const getDuration = (company) => {
  company = company.toLowerCase();
  switch (getFreeCoupon(company)) {
    default:
      return '2 weeks';
  }
};

export const pad = (value) => {
  return value < 10 ? '0' + value : value;
};

export const getTimezone = () => {
  var timezone = new Date().getTimezoneOffset();
  var sign = (timezone > 0) ? "-" : "+";
  var offset = Math.abs(timezone);
  var hours = pad(Math.floor(offset / 60));
  var minutes = pad(offset % 60);
  return sign + hours + ":" + minutes;
}
